const usage_data = () => `/customer/usage`;
const chart_data = () => `/customer/usage/chart`;

export const usageEndpoints = { usage_data, chart_data };
